module.exports = __webpack_public_path__ + "img/ticket_27767ee.svg";